import React from "react";

const RadioButtonsSexo = ({ name, defaultValue, register }) => {
  return (
    <div className="wapperRadioButton check-sexo">
      <div className="wapperRadioButton__dolar">
        <label htmlFor={"fem_" + name}>
          <input
            type="radio"
            name={name}
            id={"fem_" + name}
            value="F"
            checked={defaultValue ? defaultValue === 'F' : null}
            ref={register}
          />
          <span>Femenino</span>
        </label>
      </div>
      <div className="wapperRadioButton__soles">
        <label htmlFor={"mas_" + name}>
          <input
            type="radio"
            name={name}
            id={"mas_" + name}
            value="M"
            checked={defaultValue ? defaultValue === 'M' : null}
            ref={register}
          />
          <span>Masculino</span>
        </label>
      </div>
    </div>
  );
};

export default RadioButtonsSexo;
